import { useCurrentBoxId } from "@/modules/core/store/useCurrentSpaceManagerStore"
import { useServicesContext } from "@modules/core/services/services.context"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { UserProgramDetailsEntity } from "@modules/programs/entities/userProgramDetailsEntity"
import { ProgramType } from "@modules/programs/types/programTypes"
import { useMutation } from "@tanstack/react-query"

export const useCheckoutPayment = () => {
  const { paymentApi } = useServicesContext()
  const boxId = useCurrentBoxId()

  const {
    mutateAsync: checkoutPayment,
    isPending: isCheckingOutPayment,
    error,
  } = useMutation({
    mutationFn: async ({
      program,
      returnUrl,
      shouldReceiveClientSecret = true,
    }: {
      program: UserProgramDetailsEntity | ProgramBundleEntity
      returnUrl: string | null
      shouldReceiveClientSecret?: boolean
    }) => {
      const result =
        boxId && program.type === ProgramType.PRO
          ? await paymentApi.createBoxProProgramPaymentSubscription(program.id, returnUrl)
          : program instanceof ProgramBundleEntity
            ? await paymentApi.createProgramBundlePaymentSubscription(program.id, returnUrl)
            : await paymentApi.createProgramPaymentSubscription(program.id, returnUrl)

      if (!result.clientSecret && shouldReceiveClientSecret) {
        throw new Error("No Stripe Client Secret to pay")
      }
      if (!result.coachStripeAccountId) {
        throw new Error("No Stripe Account ID to send money to")
      }

      return result
    },
  })

  return {
    checkoutPayment,
    isCheckingOutPayment,
    error,
  }
}
